export { getStoreConfig } from './storeConfig';
